import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { getShopCookie, SHOP_META } from "../lib/shop-context";

/**
 * Phase 32 — redirect from legacy un-prefixed URLs to the shop-prefixed
 * variant when a `mercago_shop` cookie is present. When there is no cookie,
 * the caller is sent to the splash selector so they can choose.
 *
 * Usage in App.js:
 *
 *   <Route path="/producto/:slug" element={
 *     <LegacyShopRedirect subpath="/producto/:slug" />
 *   } />
 *
 * The `subpath` is a route template with `:param` placeholders that we
 * substitute with the matched `useParams()` values. The search string is
 * preserved so `?ref=email` links keep working across the redirect.
 */
export default function LegacyShopRedirect({ subpath }) {
  const params = useParams();
  const location = useLocation();
  const shop = getShopCookie();
  if (!shop) return <Navigate to="/" replace />;

  const prefix = SHOP_META[shop].prefix;
  const resolved = subpath.replace(/:([A-Za-z0-9_]+)/g, (_, key) =>
    encodeURIComponent(params[key] ?? ""),
  );
  return <Navigate to={`${prefix}${resolved}${location.search || ""}`} replace />;
}
